<template>
  <div class="zoneTri">
      <div class="row">
          <div class="col-12 col-lg-3 text-center text-lg-left">
              <ponroy-product-count></ponroy-product-count>
          </div>
          <div class="col-6 col-lg-6">
              <div class="form-group float-lg-right">
                  <select class="custom-select" v-model="priceSortModel" @change="updatePriceSort">
                      <option value="" disabled>Trier par</option>
                      <option value="ASC">Prix croissant</option>
                      <option value="DESC">Prix décroissant</option>
                  </select>
              </div>
          </div>
          <div class="col-6 col-lg-3">
              <div class="form-group float-lg-right">
                  <select class="custom-select" v-model="numberToShowModel" @change="updateNumberToShow">
                      <option value="" disabled>Afficher</option>
                      <option value="12">12 produits</option>
                      <option value="24">24 produits</option>
                  </select>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';

export default {
  name: 'ponroy-product-sort',
  data() {
    return {
      priceSortModel: '',
      numberToShowModel: ''
    };
  },
  computed: mapState('facetedFilter', {
    priceSort: state => state.priceSort,
    numberToShow: state => state.numberToShow
  }),
  watch: {
    priceSort(value) {
      this.priceSortModel = value;
    },
    numberToShow(value) {
      this.numberToShowModel = value;
    }
  },
  methods: {
    ...mapActions('facetedFilter', [
      'changePriceSort',
      'changeNumberToShow'
    ]),
    updatePriceSort() {
      this.changePriceSort(this.priceSortModel);
    },
    updateNumberToShow() {
      this.changeNumberToShow(this.numberToShowModel);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/ProductSort.vue